import { useEffect, useState } from "react";
import { GET_CLINET_ID_API } from "../api/apiPath";
import http from "../api/server";
import { useSelector } from "react-redux";

const useGetClientId = () => {
  const [clientId, setClientId] = useState(null);
   const [roleId, setRoleId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userObj } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        setLoading(true);
        const response = await http.get(
          GET_CLINET_ID_API + "/" + userObj?.userId
        );
        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setClientId(response?.data?.clientId); // Assuming the API returns an object with an 'Client ID' property
  setRoleId(response?.data?.roleId);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserEmail();
  },[]);

  return { clientId, loading, error,roleId };
};

export default useGetClientId;
